import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const ShopAuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ShopAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('shop_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMe = async () => {
      if (!token) { setLoading(false); return; }
      try {
        const res = await axios.get(`${API}/shop/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        setCustomer(res.data);
      } catch {
        localStorage.removeItem('shop_token');
        setToken(null);
      } finally {
        setLoading(false);
      }
    };
    fetchMe();
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/shop/auth/login`, { email, password });
    localStorage.setItem('shop_token', res.data.access_token);
    setToken(res.data.access_token);
    setCustomer(res.data.customer);
    return res.data;
  };

  const register = async (payload) => {
    const res = await axios.post(`${API}/shop/auth/register`, payload);
    localStorage.setItem('shop_token', res.data.access_token);
    setToken(res.data.access_token);
    setCustomer(res.data.customer);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('shop_token');
    setToken(null);
    setCustomer(null);
  };

  const authHeader = () => token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <ShopAuthContext.Provider value={{ customer, setCustomer, token, loading, login, register, logout, authHeader }}>
      {children}
    </ShopAuthContext.Provider>
  );
};

export const useShopAuth = () => {
  const ctx = useContext(ShopAuthContext);
  if (!ctx) throw new Error('useShopAuth must be used inside ShopAuthProvider');
  return ctx;
};
